import { useEffect } from "react";

/**
 * Closes the open dialog on ESC keypress.
 * Pass the open/active flag and a close callback. When `active` is false the
 * listener is detached so background dialogs don't intercept the key.
 */
export function useEscapeKey(active, onClose) {
  useEffect(() => {
    if (!active) return undefined;
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [active, onClose]);
}
